module.exports = __webpack_public_path__ + "img/icon-careers-white.043e967f.svg";